const MUTATION_TYPE = {
  updateDeleteConfirmationMessage: 'updateDeleteConfirmationMessage',
  updateContentSavedStatus: 'updateContentSavedStatus',
  editMode: 'editMode',
  setUpdater: 'setUpdater',
  freezeUpdater: 'freezeUpdater',
  setErrorWithChangingTextTestSubsection: 'setErrorWithChangingTextTestSubsection'
}

const ACTION_TYPE = {
  updateTitle: 'updateTitle',
  updateEventSettings: 'updateEventSettings',
  updateEventVoting: 'updateEventVoting',
  updateShortDescription: 'updateShortDescription',
  updateFullDescription: 'updateFullDescription',
  updateDate: 'updateDate',
  updateImages: 'updateImages',
  updateVideos: 'updateVideos',
  updateUpdater: 'updateUpdater'
}

const GETTER_TYPE = {
  isContentSaved: 'isContentSaved',
  isEditMode: 'isEditMode',
  getUpdater: 'getUpdater',
  getFreeze: 'getFreeze',
  getErrorWithChangingTextTestSubsection: 'getErrorWithChangingTextTestSubsection'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
